import { render, staticRenderFns } from "./HeadSection.vue?vue&type=template&id=1ba51e2e&"
import script from "./HeadSection.vue?vue&type=script&lang=js&"
export * from "./HeadSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports